<template>
  <admin-layout title="Candidatos(as)" menu="Candidatos">
    <div class="row">
      <div
        class="col-lg-9 col-md-7 col-xs-12 overflow-auto"
        style="height: 85vh"
      >
        <div class="row">
          <div class="col-lg-12 mb-2 color-primary">
            <h3>CRIAR CANDIDATO(A)</h3>
          </div>
          <div class="col-lg-12">
            <span class="ml-3 f14 font-weight-bold"
              >NOME DO(A) CANDIDATO(A)</span
            >
            <inputform
              v-model="candidate.name"
              type="text"
              :field="$v.candidate.name"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-12">
            <span class="ml-3 f14 font-weight-bold"
              >EMAIL DO(A) CANDIDATO(A)</span
            >
            <inputform
              v-model="candidate.email"
              type="text"
              :field="$v.candidate.email"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-12">
            <span class="ml-3 f14 font-weight-bold"
              >PORTFÓLIO DO(A) CANDIDATO(A)</span
            >
            <inputform
              v-model="candidate.personal_portfolio"
              type="text"
              :field="$v.candidate.personal_portfolio"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-12">
            <span class="ml-3 f14 font-weight-bold"
              >SITE DO(A) CANDIDATO(A)</span
            >
            <inputform
              v-model="candidate.personal_site"
              type="text"
              :field="$v.candidate.personal_site"
              class="label-bold mt-2"
            />
          </div>
          <div class="col-lg-6">
            <span class="ml-3 f14 font-weight-bold"
              >CIDADE DO(A) CANDIDATO(A)</span
            >
            <VueSuggestion
              searchURL="/cities"
              responseDataName="cities"
              :focusOut="hasCity"
              :selectedEl="city"
              :selectFirst="true"
              :clearOption="true"
              placeholder="CIDADE"
              classes="mt-1"
              inputClasses="radius-0 form-control"
            />
          </div>
          <div class="col-lg-6">
            <span class="ml-3 f14 font-weight-bold"
              >CELULAR DO(A) CANDIDATO(A)</span
            >
            <input
              class="form-control mt-1"
              type="text"
              v-model="candidate.mobile_phone"
              v-mask="'+## (##) #####-####'"
            />
          </div>
          <div class="col-lg-12 mt-3">
            <CandidateSkills :candidate_id="candidate_id" />
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-5 col-xs-12 overflow-hidden">
        <div class="row">
          <div class="col-lg-12 formJov p-2">
            <div class="row">
              <div class="col-lg-12">
                <button
                  :disabled="load"
                  @click="saveCandidate()"
                  type="buttom"
                  class="btn full btn-primary f13 p-2 radius-0"
                >
                  SALVAR
                </button>
              </div>
              <div class="col-lg-12">
                <div class="selectInput mt-2">
                  <span class="f10 pl-3 color-grey"
                    >STATUS DO(A) CANDIDATO</span
                  >
                  <select v-model="candidate.status" class="form-control">
                    <option
                      v-for="status in avaiableStatus"
                      :key="status.value"
                      :value="status.value"
                    >
                      {{ status.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-12">
                <transition name="fade">
                  <inertia-link
                    :href="talent_bank_url"
                    v-if="talent_bank_url != '#'"
                    class="btn btn-info full mt-3 f13 p-2 radius-0"
                    >VER DETALHADAMENTE</inertia-link
                  >
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import CandidateSkills from "components/CandidateSkills.vue";
import VueSuggestion from "components/VueSuggestion.vue";

export default {
  components: { VueSuggestion, CandidateSkills },
  data: () => ({
    candidate_id: 0,
    candidate: {
      name: "",
      email: "",
      personal_portfolio: "",
      personal_site: "",
      mobile_phone: "",
      remuneration: 0,
      status: 1,
    },
    city: {
      id: 0,
      name: "",
    },
    talent_bank_id: 0,
    talent_bank_url: "#",
    load: false,
    avaiableStatus: [
      { text: "Desativado", value: 0 },
      { text: "Ativado", value: 1 },
    ],
  }),
  mounted() {
    eventBus.$on(`clearInput-cities`, () => {
      this.city = {
        id: 0,
        name: "",
      };
    });
  },
  computed: {
    axiosData() {
      let candidates = { ...this.candidate, ...{ city_id: this.city.id } };
      let url = this.candidate_id
        ? `/recruiters/talent_banks/${this.talent_bank_id}/candidate/edit`
        : "/recruiters/talent_banks/candidates";
      return {
        method: this.candidate_id ? "put" : "post",
        url: url,
        data: { candidates },
      };
    },
  },
  methods: {
    saveCandidate() {
      this.$v.candidate.$touch();
      if (this.$v.candidate.$error) {
        this.$toast.error("PREENCHA CORRETAMENTE OS CAMPOS PARA CONTINUAR");
        return;
      }

      axios(this.axiosData).then((response) => {
        if (!response.data.status && !response.data.updated) {
          this.$toast.error("Não foi possivel salvar este candidato.");
          return;
        }

        if (response.data.talent_bank) {
          this.candidate_id = response.data.talent_bank.candidate_id;
          this.talent_bank_id = response.data.talent_bank.id;
          this.talent_bank_url = `/recruiters/talent_banks/${this.talent_bank_id}/candidate`;
        }
        this.$toast.success("Candidato salvo com sucesso!");
      });
    },
    hasCity(event, items) {
      this.city = items[0] ? items[0] : { id: 0, name: "" };
    },
  },
  validations: {
    candidate: {
      name: { required, minLength: minLength(2) },
      email: { required, email },
      mobile_phone: { minLength: minLength(4) },
      personal_portfolio: { minLength: minLength(4) },
      personal_site: { minLength: minLength(4) },
    },
  },
};
</script>